import {
  ModalHeader as CModalHeader,
  Flex,
  Box,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import { AiOutlineClose } from "react-icons/ai";

interface ModalHeaderProps {
  title?: string;
  onClose?: () => void;
}
export const ModalHeader = ({ title, onClose }: ModalHeaderProps) => {
  const { colorMode } = useColorMode();
  return (
    <CModalHeader p={0}>
      <Flex justifyContent="space-between" alignItems="center">
        <Text m={0} className="h5" color="Text_Main">
          {title}
        </Text>
        <Box as="button" ml={2} h={6} onClick={onClose}>
          <AiOutlineClose
            size={20}
            color={colorMode === "light" ? "#000000" : "#FFFFFF"}
          />
        </Box>
      </Flex>
    </CModalHeader>
  );
};
